module.exports = __webpack_public_path__ + "static/lunchtype22-light-webfont-9a32266aa520d92ada2458168b543385.ttf";